namespace GeniuzPOS.Inventory {
    export interface IcStkAdjCodeRow {
        Id?: number;
        StkAdjType?: number;
        StkAdjCode?: string;
        StkAdjDesc?: string;
        StkAdjcodeName?: string;
    }

    export namespace IcStkAdjCodeRow {
        export const idProperty = 'StkAdjCode';
        export const nameProperty = 'StkAdjDesc';
        export const localTextPrefix = 'Inventory.IcStkAdjCode';
        export const lookupKey = 'Inventory.IcStkAdjCode';

        export function getLookup(): Q.Lookup<IcStkAdjCodeRow> {
            return Q.getLookup<IcStkAdjCodeRow>('Inventory.IcStkAdjCode');
        }
        export const deletePermission = '2Inventory:ระบบ:ประเภทการปรับปรุงสต๊อก:Modify';
        export const insertPermission = '2Inventory:ระบบ:ประเภทการปรับปรุงสต๊อก:Modify';
        export const readPermission = '2Inventory:ระบบ:ประเภทการปรับปรุงสต๊อก:View';
        export const updatePermission = '2Inventory:ระบบ:ประเภทการปรับปรุงสต๊อก:Modify';

        export declare const enum Fields {
            Id = "Id",
            StkAdjType = "StkAdjType",
            StkAdjCode = "StkAdjCode",
            StkAdjDesc = "StkAdjDesc",
            StkAdjcodeName = "StkAdjcodeName"
        }
    }
}
